import React from 'react';
import { BzImage } from '@benzinga/image';
import { SmartLink } from '@benzinga/analytics';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import type { AdvertorialProductProps } from './index';

export const AdvertorialProductDefaultLayout: React.FC<AdvertorialProductProps> = ({
  btn_label,
  description,
  image,
  items,
  link,
  title,
}) => {
  return (
    <div className="my-2">
      <div className="">
        <SmartLink className="cta-link-button" href={link} label={`Ad Summary`}>
          <h3
            className="ad-product-title p-2 text-white bg-[#121d2e] bg-[linear-gradient(rgb(36,52,79)_0%,rgba(21,36,50,0)_100%)]"
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(title) }}
          />
        </SmartLink>
      </div>
      <div className="flex flex-col sm:flex-row border-2 border-t-0">
        <div className="basis-8/12 ">
          {description && (
            <div
              className="ad-product-desc p-2 leading-[1.4] [&_p]:mb-2"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }}
            />
          )}
        </div>
        <div className="basis-4/12 order-first md:order-3">
          <div className="product-thumbnail relative h-full min-h-[250px]">
            <BzImage
              alt=""
              layout="fill"
              loaderProps={{ width: 230 }}
              loading={'eager'}
              objectFit="contain"
              preload={true}
              src={image}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="product-items border-x-2 flex flex-col sm:flex-row justify-between ">
          {items &&
            items?.length > 0 &&
            items.map(item =>
              item?.advertorial_item_label ? (
                <React.Fragment key={item.advertorial_item_label}>
                  <div className="product-item p-2 border-b-2 sm:border-b-0">
                    <span>
                      <b>{item.advertorial_item_label}: </b>
                    </span>
                    {item?.advertorial_item_value ? <span>{item.advertorial_item_value} </span> : null}
                  </div>
                </React.Fragment>
              ) : null,
            )}
        </div>
        <SmartLink className="cta-link-button" href={link} label={`Ad Summary`}>
          <button className="p-4 bg-bzblue-700 md w-full text-white">{btn_label}</button>
        </SmartLink>
      </div>
    </div>
  );
};
